module.exports = __webpack_public_path__ + "static/media/email.de5db18e.svg";